export const isElectron = typeof process !== 'undefined' && process.versions.electron;